import { BaseColumnFormatter } from "./BaseColumnFormatter";

export class DateTimeFormatter extends BaseColumnFormatter
{
    constructor(width: string = "185px")
    {
        super();
        this.width = width;
    }
    override format(value: any): any
    {
        if (value)
            try
            {
                let date = new Date(value);
                return date.toLocaleString();
            } catch (e)
            {
            }
        return value;
    }
}